
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSources01 as ObiSources01Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-sources-01.js';
 
 
 

 
 export const ObiSources01 = createComponent({
   react: React,
   tagName: 'obi-sources-01',
   elementClass: ObiSources01Element,
   events: {
     
   }
  });
 
 